<template>
  <div class="container pt-0">
    <div class="header mb-5">
    </div>

    <div class="row line">
      <div class="col-lg pl-0 w-100">
        <Intro />
      </div>
    
      <div class="col-lg pl-0 mb-4 searchContainer">
        <div class="d-flex">
          <img class="locationPinSearch" src="../assets/location_pin_search.svg" alt="Distance pin">
          <h3 class="findYourGiftText mb-2">Find your perfect gift nearby</h3>
        </div>
        <postcode-finder @selectpostcode="selectpostcode" />
      </div>

    </div>
    
    <div class="row mt-1">
      <div class="col-12 col-md-6" :key="index" v-for="(account,index) in list">
        <Card :accountData="account" />
      </div>

      <infinite-loading @infinite="infiniteHandler" v-if="user_location !== null">
        <div slot="no-more"></div>
      </infinite-loading>
      <Footer />
    </div>
  </div>
</template>

<script>
import Card from "./Card";
import Intro from "./Intro";
import Footer from "./Footer";
import PostcodeFinder from "./PostcodeFinder";
import InfiniteLoading from "vue-infinite-loading";
import axios from "axios";
export default {
  name: "SupportPage",
  components: {
    Card,
    Intro,
    InfiniteLoading,
    Footer,
    PostcodeFinder
  },
  data() {
    return {
      page: 1,
      list: [],
      user_location:null,
      query: `
    					query(
                $page:Int!,
                $limit:Int!,
                $exclude_sandbox_accounts:Boolean,
                $toggle_directory_account:Boolean,
                $order_by:String,
                $distance_from:LocationInput
                $distance_unit:String
              ){
                AccountsPaginated(
                  page:$page, 
                  limit:$limit, 
                  exclude_sandbox_accounts:$exclude_sandbox_accounts,
                  toggle_directory_account:$toggle_directory_account,
                  order_by:$order_by,
                  distance_from:$distance_from,
                  distance_unit:$distance_unit
                ){
                  total,
                  per_page,
                  data{
                    id
                    name
                    distance
                    page_text
                    domain
                    ThemeElementStyles{
                      theme_element_id,
                      property,
                      value
                    },
                    Image {
                      url
                    }
                  }
                }
              }
    					`
    };
  },
  mounted() {


    // get url location 
    this.user_location = this.getUrlCoords();
    
    // if no url location try and get browser location
    if (!this.user_location && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position)=>{
        if(position.coords && position.coords.latitude && position.coords.longitude){
          this.user_location = {
            latitude:position.coords.latitude,
            longitude:position.coords.longitude
          };
        }else{
          this.user_location = false;
        }
        this.page = 1;
        this.infiniteHandler();
      },
      ()=>{
        this.user_location = false;
      });
    }


  },

  watch: {
      
  },

  methods: {

    getUrlCoords(){

      let position = {
        latitude:null,
        longitude:null
      };


      if(this.$route.params.location){
        switch(this.$route.params.location.toLowerCase()) {
          case 'sheffield':
            position.latitude = 53.383331;
            position.longitude = -1.466667;
            break;
          case 'leeds':
            position.latitude = 53.801277;
            position.longitude = -1.548567;
            break;
          case 'london':
            position.latitude = 51.509865;
            position.longitude = -0.118092;
            break;
          case 'manchester':
            position.latitude = 53.483959;
            position.longitude = -2.244644;
            break;
          case 'liverpool':
            position.latitude = 53.400002;
            position.longitude = -2.983333;
            break;
          case 'birmingham':
            position.latitude = 52.489471;
            position.longitude = -1.898575;
            break;
          default:
            position.latitude = null;
            position.longitude = null;
        }
      }


      if(position.latitude !== null && position.longitude !== null)
        return position;
      return null;


    },

    selectpostcode(latitude, longitude){
      this.user_location = {
        latitude:latitude,
        longitude:longitude
      }

      this.page = 1;
      this.infiniteHandler();
    },
    /**
     * gets the data for the next page when the user scrolls to the bottom of the screen.
     */
    infiniteHandler($state) {

      // reset list if we're getting the first page
      if(this.page == 1){
        this.list = [];
      }

      let variables = {
        distance_unit:'miles',
        product_active: 1,
        store_type_id: 1,
        limit: 20,
        page: this.page,
        toggle_directory_account: true,
        exclude_sandbox_accounts: true
      };

      if(this.user_location && this.user_location.longitude && this.user_location.latitude){
        variables.distance_from = {
          longitude:this.user_location.longitude,
          latitude:this.user_location.latitude
        };
        variables.order_by = 'distance';
      }


      axios({
        url: process.env.VUE_APP_API_GRAPH_URL,
        method: "post",
        data: {
          query: this.query,
          variables: variables
        }
      })
        .then(({ data }) => {
          this.page = variables.page+1;
          if ($state) {
            const accounts = data.data.AccountsPaginated.data;
            if (accounts.length) {
              if(variables.page == 1)
                this.list = accounts;
              else
                this.list.push(...accounts);
              $state.loaded();
            } else {
              $state.complete();
            }
          } else {
            this.list = data.data.AccountsPaginated.data;
          }
        })
        .catch(() => {
          this.$bus.$emit(
            "show_modal_alert",
            "Oops, something went wrong, please try again."
          );
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
  font-family: 'Manrope';
  src: url('../assets/fonts/Manrope.ttf') format('truetype');
  font-style: normal;
}
@font-face {
  font-family: 'Manrope-ExtraBold';
  src: url('../assets/fonts/Manrope-ExtraBold.ttf') format('truetype');
  font-style: normal;
}
.searchContainer {
  margin: 240px 0 0 0;
}
.findYourGiftText {
  font-family: 'Manrope-ExtraBold';
  color: #042750;
  font-size: 16px !important;
  font-weight: 800;
}
.locationPinSearch {
  height: 20px;
  margin: -3px 7px 0 0;
}
.header {
  width: 100%;
  height: 100%;
  background-image: url("../assets/tree_foliage.png");
  background-repeat: no-repeat;
  position: absolute;
  right: 0px;
  bottom: 30px;
  z-index: -1;
}
.line {
  margin: 0 6px 0 6px;
  border-bottom: 1px solid #E2E2E2;
}

@media (max-width: 992px) {
  .searchContainer {
    margin: 12px 0 0 0;
  }
}

  @media screen and (min-width: 1640px) {
    .header {
      background-size: contain;
      background-position: center 0;
      top: -120px;
    }
    @media screen and (max-height: 499px) {
        .header {
          background-size: cover;
        }
      }
  }

  @media only screen and (max-width : 1639px) {
    .header {
      background-position: right 0;
    }
  }
</style>
